import {useRef} from 'react';
import ScaledTemplate from '../Tabs/ScaledTemplate';

function App(props) {

  var expressedWidth = props.expressedWidth;
  var width = props.width;
  var height = props.height;
  var aTemplate = props.aTemplate;
  var scrollAmt = props.scrollAmt;
  var onClick = props.onClick;
  var chains = props.chains;

  var ref3 = useRef();

  var w = (expressedWidth);
  var h = (expressedWidth) * (height - 42)/width;
  
  var cList = aTemplate.c;
  var whichFE = cList._g.ss;
  var fe = cList.fe;
  if (fe[whichFE]){
  }else{
    whichFE = Object.keys(fe)[0];
  }

  var offsetLeft = 0; 
  var offsetTop = 0;

  if (ref3 && ref3.current){
    offsetTop = ref3.current.offsetTop - scrollAmt;
    offsetLeft = ref3.current.offsetLeft;
  }

  var inside = <ScaledTemplate chains={chains} overallWidth={width} w={w} h={h} error={false} whichFEOrPU={{t:'fe', v:whichFE}} currentList={cList} onClick={onClick} offsetTop={offsetTop} offsetLeft={offsetLeft}/>

  // clickTemplate(aTemplate.i)
  return <div ref={ref3} className='col-md-5 cardBlockchain col-11' onClick={onClick}> <center>
    {inside}</center>
  </div>  

//
}

export default App;
